import connection from "@shared/utils/connection";

export async function guardarDispositivoPersona(firebaseToken) {
    try {
        return await connection({
            method: "POST",
            url: "/api/backend/dispositivos",
            body: { token: firebaseToken }
        });
    } catch (err) {
        console.error("Error al guardar el dispositivo:", err);
        throw new Error("No se pudo guardar el dispositivo");
    }
}
